<app-quick-action-dialog
  [isOpen]="isDialogOpen"
  [title]="dialogTitle"
  [isCloseable]="true"
  (backdropClick)="onBackdropClick()"
  (close)="onClose()"
>
  <!-- Content slot for form -->
  <div slot="content" class="account-form">
    <kc-input
      [infoLabel]="{ label: 'Account name' }"
      [placeholder]="'Enter account name'"
      [(ngModel)]="accountName"
    />
  </div>

  <!-- Footer slot for action button -->
  <div slot="footer">
    <kc-button
      [text]="buttonText"
      [variant]="'primary'"
      [size]="'m'"
      [isFullWidth]="true"
      [isDisabled]="!accountName.trim()"
      (buttonClick)="onCreateAccount()"
    />
  </div>
</app-quick-action-dialog>
